/* eslint-disable @bigbinary/neeto/use-neetoui-classes */
import { DropdownMenu } from "@bigbinary/neeto-atoms";
import { Plus } from "lucide-react";

const AddAction = ({ actions }) => (
  <DropdownMenu
    dropdownProps={{ align: "end", side: "bottom" }}
    customTarget={
      <button
        className="text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-sidebar-ring absolute end-1 top-1.5 flex aspect-square w-5 items-center justify-center rounded-md p-0 outline-hidden focus-visible:ring-2 md:opacity-0 md:group-focus-within/menu-item:opacity-100 md:group-hover/menu-item:opacity-100"
        data-testid="add-dropdown-trigger"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <Plus />
      </button>
    }
  >
    {actions.map(action => (
      <DropdownMenu.MenuItem.Button
        key={action.key}
        onClick={() => {
          action.onClick?.();
        }}
      >
        {action.label}
      </DropdownMenu.MenuItem.Button>
    ))}
  </DropdownMenu>
);

export default AddAction;
